import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchWishlistFromServer,
  notifyMeServer,
  removeItemFromWishlistServer,
} from "../../slices/wishlist";

import {
  addItemToCartServer,
  updateLocalCart,
} from "../../slices/cart";

import { toast } from "react-toastify";
import "./Favourites.css";
import { useNavigate } from "react-router-dom";
import EmptyState from "../helpers/EmptyState";
import { MdInbox } from "react-icons/md";
import ModalLoader from "../helpers/ModalLoader";
import SessionService from "../../services/SessionService";

export default function Favourites() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { items, loading } = useSelector((state) => state.wishlist);
  const isLoggedIn = SessionService.isLoggedIn;

  useEffect(() => {
    dispatch(fetchWishlistFromServer());
  }, [dispatch]);

  const handleNotify = (productId) => {
    dispatch(notifyMeServer(productId));
    toast.info("You'll be notified when this item is back in stock!");
  };

  const handleRemove = async (productId) => {
    await dispatch(removeItemFromWishlistServer(productId));
    dispatch(fetchWishlistFromServer());
    toast.success("Removed from wishlist");
  };

  const handleMoveToCart = async (productId) => {
    const item = items.find((p) => p.product_id === productId);
    if (!item) return;

    await dispatch(removeItemFromWishlistServer(productId));

    if (isLoggedIn) {
      await dispatch(
        addItemToCartServer({
          product_id: productId,
          quantity: 1,
        })
      );
    } else {
      dispatch(
        updateLocalCart({
          action: "ADD",
          itemPayload: {
            product: item,
            variant: item.variant,
            quantity: 1,
          },
        })
      );
    }

    dispatch(fetchWishlistFromServer());

    toast.success("Item moved to cart!");
  };

  return (
    <div className="wishlist-container">
      <div className="wishlist-header">
        <h2>My Wishlist</h2>
        {items?.length > 0 && <span>{items.length} items</span>}
      </div>

      {loading ? (
        <ModalLoader />
      ) : !items || items.length === 0 ? (
        <EmptyState
          title="Your Wishlist is Empty"
          description="Save items you love and shop whenever you like."
          buttonText="Browse Products"
          onButtonClick={() => navigate("/shop")}
          icon={MdInbox}
        />
      ) : (
        <div className="wishlist-grid">
          {items.map((product) => (
            <div className="wishlist-card" key={product.product_id}>
              <div
                className="wishlist-image-wrapper"
                onClick={() => navigate(`/product/${product.slug}`)}
              >
                <img
                  src={product.primary_image_url}
                  alt={product.product_name}
                />

                {!product.is_in_stock && (
                  <span className="wishlist-badge">Out of Stock</span>
                )}
              </div>

              <div
                className="wishlist-info"
                onClick={() => navigate(`/product/${product.slug}`)}
              >
                <h3>{product.product_name}</h3>
                <p className={product.is_in_stock ? "in-stock" : "out-stock"}>
                  {product.is_in_stock ? "Available" : "Unavailable"}
                </p>
              </div>

              <div className="wishlist-actions">
                {/* {product.is_in_stock && (
                  <button
                    className="btn-move"
                    onClick={() => handleMoveToCart(product.product_id)}
                  >
                    Move to Cart
                  </button>
                )} */}

                {!product.is_in_stock && (
                  <button
                    className="btn-notify"
                    onClick={() => handleNotify(product.product_id)}
                  >
                    Notify Me
                  </button>
                )}

                {/* Remove */}
                <button
                  className="btn-remove"
                  onClick={() => handleRemove(product.product_id)}
                >
                  Remove
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
